import './assets/style.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router/index.js'

import PrimeVue from 'primevue/config'
import ToastService from 'primevue/toastservice'

import GlobalPvComponents from '@/plugins/GlobalPvComponents.js'
import CustomComponents from '@/plugins/CustomComponents.js'
import GlobalMdiIcons from '@/plugins/GlobalMdiIcons'

import Lara from '@primeuix/themes/lara'

import localeData from 'primelocale/pl.json'

const app = createApp(App)

app.use(PrimeVue, {
  theme: {
    preset: Lara,
    options: {
      prefix: 'p', // domyślnie "p"
      // darkModeSelector: 'system', // 🌓 automatyczne przełączanie na podstawie systemu
      darkModeSelector: 'false', // 🌓 automatyczne przełączanie na podstawie systemu
      cssLayer: {
        name: 'primevue',
        order: 'tailwind-base, primevue, tailwind-utilities'
      }
    }
  },
  locale: localeData.pl
})

app.use(GlobalPvComponents)
app.use(CustomComponents)
app.use(GlobalMdiIcons)
app.use(createPinia())
app.use(router)
app.use(ToastService)

app.mount('#app')
